import { IrisUserComponent } from '@iris/common/modules/user-common/modules/sk-user-wrapper/components/sk-iris-user.component';
import { IrisFilterChipRenderingOptions } from './chip-rendering-options';
import { ComponentRef } from '@angular/core';

export function userChipRenderingOptions<TEntity>(userIdGetter?: (entity: TEntity) => number): IrisFilterChipRenderingOptions<IrisUserComponent, TEntity> {
  return {
    component: IrisUserComponent,
    initComponentFn: (componentRef: ComponentRef<IrisUserComponent>, entity) => {
      componentRef.setInput('userId', userIdGetter ? userIdGetter(entity) : (entity as unknown as number));
      componentRef.setInput('avatarSize', 'sm');
      componentRef.setInput('showOnlyAvatar', true);
    },
  } as IrisFilterChipRenderingOptions<IrisUserComponent, TEntity>;
}
